<template>
  <div data-cy="base-color-picker">
    <v-menu
      v-model="menu"
      top
      nudge-bottom="105"
      nudge-left="16"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <span v-if="labelText" class="mr-2">{{ labelText }}</span>
        <div v-if="$attrs.disabled" :style="swatchStyle" />
        <div v-if="!$attrs.disabled" :style="swatchStyle" v-on="on" />
      </template>
      <v-card>
        <v-card-text class="pa-0">
          <v-color-picker :value="value" @input="(newValue) => $emit('input', newValue)" flat v-bind="$attrs"  />
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { getRandomColor } from "../helper/helper";

export default {
  props: {
    value: {
      type: String,
      default: function () {
        return getRandomColor()
      },
    },
    labelText: {
      type: String,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menu: false,
    };
  },
  mounted() {
    this.$emit("input", this.value);
  },
  computed: {
    swatchStyle() {
      const { value, menu } = this;
      return {
        backgroundColor: value,
        display: "inline-block",
        verticalAlign: "middle",
        cursor: "pointer",
        height: "30px",
        width: this.dense ? "50px" : "150px",
        borderRadius: menu ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
  },
};
</script>

